import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description =
  'アフリカ向けアプリを開発いたしました。このアプリは、デジタルを活用したユーザー接点の展開のためのものです。弊社はデジタルトランスフォーメーションを推進するため、ワークショップの開催からサービス開発までを支援を実施しました。'

const ogpImg = 'https://aitria.co.jp/images/img/cases/mirron/ogp_mirron.png'

export const mirronPageMeta: PageMeta = {
  title: 'mirron | 事例 | Aitria（アイトリア）',
  description,
  keyword: 'UX/UI モバイルアプリ システム化 DX推進 フロントエンド開発',
  image: ogpImg,
  url: `${SITE_URL}/cases/mirron/`,
}

export const mirronSchema = buildCaseStudySchema({
  slug: 'mirron',
  pageTitle: mirronPageMeta.title,
  description: mirronPageMeta.description,
  headline: 'mirron',
  alternativeHeadline: '大手化学メーカー',
  primaryImage: ogpImg,
  images: [ogpImg, 'https://aitria.co.jp/images/img/cases/caseStudyTop/mirron.webp'],
  clientName: '大手化学メーカー',
  breadcrumbLabel: 'mirron',
})
